import {axios, getLastAccessToken} from './api';
import {AUDIT_SESSION_HEADER, getAuditSessionId} from 'lib/audit-session';

export default class AuditApi {
  static baseUrl = '/v2/illustrator/audit';

  static async saveAuditEvent(data, config) {
    return axios.post(this.baseUrl, data, config);
  }

  /**
   * Fire-and-forget request that survives the page unloading, which axios does not reliably do.
   */
  static saveAuditEventKeepalive(data) {
    try {
      const headers = {'Content-Type': 'application/json'};
      const accessToken = getLastAccessToken();
      const sessionId = getAuditSessionId();

      if (accessToken) headers.Authorization = `Bearer ${accessToken}`;
      if (sessionId) headers[AUDIT_SESSION_HEADER] = sessionId;

      fetch(`${window.env.REACT_APP_API_HOST}${this.baseUrl}`, {
        method: 'POST',
        keepalive: true,
        headers,
        body: JSON.stringify(data),
      }).catch(() => {});
    } catch (e) {}
  }
}
